<template>
  <div>
    <div v-for="(event, index) in shownEvents" :key="index">
      <event-card :event="event" :is-past-event="isPastEvent"></event-card>
    </div>
    <button class="button events__button" v-if="isPastEvent && isMoreButtonVisible" @click="showMoreEvents">
      Показать больше мероприятий
    </button>
  </div>
</template>

<script>
import EventCard from './EventCard.vue';

export default {
  name: 'EventCardsList',
  components: {
    EventCard,
  },
  props: {
    events: {
      type: Array,
      required: true,
    },
    isPastEvent: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      itemsToShow: 12,
    };
  },
  computed: {
    shownEvents() {
      return this.isPastEvent ? this.events.slice(0, this.itemsToShow) : this.events;
    },
    isMoreButtonVisible() {
      return this.itemsToShow < this.events.length;
    },
  },
  methods: {
    showMoreEvents() {
      this.itemsToShow += 5;
    },
  },
};
</script>
